<template>
  <Day day="03.12.2025">
    <div slot="page-content">
      <h3>Alle bei der Mutti</h3>
      <p>
        <img src="@/assets/day3.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day03',
  components: {
    Day
  }
}
</script>
